import utils from "./utils";
import ProductConstants from 'constants/ProductConstants';

const initialDefaults = (formRef, data) => {

    let requestData = data.data.bi_request;
    let ptValue = requestData.PR_PT;
    let pptValue = requestData.PR_PPT;
    let frequency = requestData.INPUT_MODE;
    let income_payout = requestData.IncomeBenefitPayoutFrequency;
    let planOption = requestData.PlanOption;
    let premiumBreakBenefit = requestData.PremiumBreakBenefit;
    let accrualOfSurvivalBenefit = requestData.AccrualOfSurvivalBenefit_1;
    let asbStartYearOne = requestData.ASB_StartPolicyYear_1
    let asbEndYearOne = requestData.ASB_EndPolicyYear_1
    let accrualOfSurvivalBenefit_2 = requestData.AccrualOfSurvivalBenefit_2;
    let asbStartYearTwo = requestData.ASB_StartPolicyYear_2
    let asbEndYearTwo = requestData.ASB_EndPolicyYear_2
    let accrualOfSurvivalBenefit_3 = requestData.AccrualOfSurvivalBenefit_3;
    let asbStartYearThree = requestData.ASB_StartPolicyYear_3
    let asbEndYearThree = requestData.ASB_EndPolicyYear_3
    let preponementOfFutureIncome_1 = requestData.PreponementOfFutureIncome_1;
    let preponementStartYearOne = requestData.PFI_StartPolicyYear_1;
    let preponementEndYearOne = requestData.PFI_EndPolicyYear_1;
    let preponementStartYearTwo = requestData.PFI_StartPolicyYear_2;
    let preponementEndYearTwo = requestData.PFI_EndPolicyYear_2;
    let preponementStartYearThree = requestData.PFI_StartPolicyYear_3;
    let preponementEndYearThree = requestData.PFI_EndPolicyYear_3;
    let preponementOfFutureIncome_2 = requestData.PreponementOfFutureIncome_2;
    let preponementOfFutureIncome_3 = requestData.PreponementOfFutureIncome_3;
    let autoRenewalBooster = requestData.AutoRenewalBooster;
    let saDeathMultiple = requestData.PR_SAMF
	let SameProposer = requestData?.SameProposer

    //Initial value of policy term
    formRef.$('policy-term').set('value', { label: ptValue, id: ptValue })

    //Initial value of Premium paying term
    let pptList = utils.generatePPTList(planOption, ptValue)

    formRef.$("premium-paying-term").set("extra", {
        ...formRef.$("premium-paying-term").extra,
        optionList: pptList,
    });
    formRef.$('premium-paying-term').set('value', { label: pptValue, id: pptValue })

    // Initial value of Premium Paying Frequency
    let frequencyLabel = "";
    switch (Number(frequency)) {
        case 1:
            frequencyLabel = "Annual";
            break;

        case 2:
            frequencyLabel = "Semi-Annual";
            break;

        case 3:
            frequencyLabel = "Quarterly";
            break;

        case 4:
            frequencyLabel = "Monthly";

            break;

        default:
            break;
    }
    formRef.$("premium-paying-frequency").set("disabled", true)
    formRef.$("premium-paying-frequency").set("value", {
        id: frequency,
        label: frequencyLabel,
    });


    // Initial value of income benefit payout frequency
    let payoutLabel = "";
    switch (Number(income_payout)) {
        case 1:
            payoutLabel = "Annual";
            break;

        case 2:
            payoutLabel = "Semi-Annual";
            break;

        case 3:
            payoutLabel = "Quarterly";
            break;

        case 4:
            payoutLabel = "Monthly";

            break;

        default:
            break;
    }
    formRef.$("income-benefit-payout-frequency").set("value", {
        id: frequency,
        label: payoutLabel,
    });

    // Initial value of plan option
    let planOptionLabel = "";
    switch (Number(planOption)) {
        case 1:
            planOptionLabel = "Immediate income";
            break;

        case 2:
            planOptionLabel = " Deferred income";
            break;


        default:
            break;
    }
    formRef.$("plan-option").set("value", {
        id: planOption,
        label: planOptionLabel,
    });

    // Initial value of premium break benefit
    switch (Number(premiumBreakBenefit)) {
        case 3:
            formRef.$("premium-break-benefit").set("value", {
                id: premiumBreakBenefit,
                label: 'Yes',
            });
            break;

        case 4:
            formRef.$("premium-break-benefit").set("value", {
                id: premiumBreakBenefit,
                label: 'No',
            });
            break;

        default:
            break;

    }
    if (formRef.$("premium-paying-term").value.id == 5) {
        formRef.$("premium-break-benefit").set("disabled", false);

    }

    // Initial value of accrual of survival benefits
    switch (Number(accrualOfSurvivalBenefit)) {
        case 5:
            formRef.$("accrual-of-survival-benefits").set("value", {
                id: accrualOfSurvivalBenefit,
                label: 'Yes',
            });
            break;

        case 6:
            formRef.$("accrual-of-survival-benefits").set("value", {
                id: accrualOfSurvivalBenefit,
                label: 'No',
            });
            break;
        default:
            break;
    }
    // formRef.$("accrual-of-survival-benefits").set("disabled", true);
    utils.handleAsbCondition(formRef, accrualOfSurvivalBenefit)

    // Initial value of ASB Start year 1
    let asbStartYearOneList = utils.fetchASBstartPolicyOne(planOption, ptValue, pptValue, formRef.$("asb-start-policy-year-(1st-opt-in)").extra.preDefinedOptList) 
    formRef.$("asb-start-policy-year-(1st-opt-in)").set("extra", {
        ...formRef.$("asb-start-policy-year-(1st-opt-in)").extra,
        optionList: asbStartYearOneList,
    });
    let asbStartYearOneOpt = asbStartYearOneList.filter((item) => Number(asbStartYearOne) === item.id)
    if(asbStartYearOneOpt.length > 0) formRef.$("asb-start-policy-year-(1st-opt-in)").set("value", asbStartYearOneOpt[0])

    // Initial value of ASB End year 1
    let asbEndYearOneList = utils.fetchASBendPolicyOne(formRef.$("asb-start-policy-year-(1st-opt-in)").value.id, asbStartYearOneList, formRef.$("asb-end-policy-year-(1st-opt-in)").extra.preDefinedOptList)
    formRef.$("asb-end-policy-year-(1st-opt-in)").set("extra", {
        ...formRef.$("asb-end-policy-year-(1st-opt-in)").extra,
        optionList: asbEndYearOneList,
    });
    let asbEndYearOneOpt = asbEndYearOneList.filter((item) => Number(asbEndYearOne) === Number(item.id))
    if(asbEndYearOneOpt.length > 0) formRef.$("asb-end-policy-year-(1st-opt-in)").set("value", asbEndYearOneOpt[0])

    // Initial value of accrual of survival benefits 2
    switch (Number(accrualOfSurvivalBenefit_2)) {
        case 87:
            formRef.$("accrual-of-survival-benefits-year-2").set("value", {
                id: accrualOfSurvivalBenefit_2,
                label: 'Yes',
            });
            break;

        case 88:
            formRef.$("accrual-of-survival-benefits-year-2").set("value", {
                id: accrualOfSurvivalBenefit_2,
                label: 'No',
            });
            break;

        default:
            break;
    }
    utils.handleAsbTwoCondition(formRef, accrualOfSurvivalBenefit_2)

     // Initial value of ASB Start year 2
    let asbTwoStartYearOneList = utils.fetchASBendPolicyOne(
        formRef.$("asb-end-policy-year-(1st-opt-in)").value.id + 2,
        formRef.$("asb-end-policy-year-(1st-opt-in)").extra.optionList,
        formRef.$("asb-start-policy-year-(2nd-opt-in)").extra.preDefinedOptList
    );
    formRef.$("asb-start-policy-year-(2nd-opt-in)").set("extra", {
        ...formRef.$("asb-start-policy-year-(2nd-opt-in)").extra,
        optionList: asbTwoStartYearOneList,
    });
     let asbTwoStartYearOneOpt = asbTwoStartYearOneList.filter((item) => Number(asbStartYearTwo) === item.id)
     if(asbTwoStartYearOneOpt.length > 0) formRef.$("asb-start-policy-year-(2nd-opt-in)").set("value", asbTwoStartYearOneOpt[0])
 
     // Initial value of ASB End year 2
     let asbTwoEndYearOneList = utils.fetchASBendPolicyOne(formRef.$("asb-start-policy-year-(2nd-opt-in)").value.id, asbTwoStartYearOneList, formRef.$("asb-end-policy-year-(2nd-opt-in)").extra.preDefinedOptList)
     formRef.$("asb-end-policy-year-(2nd-opt-in)").set("extra", {
         ...formRef.$("asb-end-policy-year-(2nd-opt-in)").extra,
         optionList: asbTwoEndYearOneList,
     });
     let asbTwoEndYearOneOpt = asbTwoEndYearOneList.filter((item) => Number(asbEndYearTwo) === item.id)
     if(asbTwoEndYearOneOpt.length > 0) formRef.$("asb-end-policy-year-(2nd-opt-in)").set("value", asbTwoEndYearOneOpt[0])

     
    // Initial value of accrual of survival benefits 3
    switch (Number(accrualOfSurvivalBenefit_3)) {
        case 165:
            formRef.$("accrual-of-survival-benefits-year-3").set("value", {
                id: accrualOfSurvivalBenefit_3,
                label: 'Yes',
            });
            break;

        case 166:
            formRef.$("accrual-of-survival-benefits-year-3").set("value", {
                id: accrualOfSurvivalBenefit_3,
                label: 'No',
            });
            break;

        default:
            break;
    }
    utils.handleAsbThreeCondition(formRef, accrualOfSurvivalBenefit_3)

    // Initial value of ASB Start year 2
    let asbThreeStartYearOneList = utils.fetchASBendPolicyOne(
        formRef.$("asb-end-policy-year-(2nd-opt-in)").value.id + 2,
        formRef.$("asb-end-policy-year-(2nd-opt-in)").extra.optionList,
        formRef.$("asb-start-policy-year-(3rd-opt-in)").extra.preDefinedOptList
    );
    formRef.$("asb-start-policy-year-(3rd-opt-in)").set("extra", {
        ...formRef.$("asb-start-policy-year-(3rd-opt-in)").extra,
        optionList: asbThreeStartYearOneList,
    });
    let asbThreeStartYearOneOpt = asbThreeStartYearOneList.filter((item) => Number(asbStartYearThree) === item.id)
    if(asbThreeStartYearOneOpt.length > 0) formRef.$("asb-start-policy-year-(3rd-opt-in)").set("value", asbThreeStartYearOneOpt[0])

    // Initial value of ASB End year 2
    let asbThreeEndYearOneList = utils.fetchASBendPolicyOne(formRef.$("asb-start-policy-year-(3rd-opt-in)").value.id, asbThreeStartYearOneList, formRef.$("asb-start-policy-year-(3rd-opt-in)").extra.preDefinedOptList)
    formRef.$("asb-start-policy-year-(3rd-opt-in)").set("extra", {
        ...formRef.$("asb-start-policy-year-(3rd-opt-in)").extra,
        optionList: asbThreeEndYearOneList,
    });
    let asbThreeEndYearOneOpt = asbThreeEndYearOneList.filter((item) => Number(asbEndYearThree) === item.id)
    if(asbThreeEndYearOneOpt.length > 0) formRef.$("asb-end-policy-year-(3rd-opt-in)").set("value", asbThreeEndYearOneOpt[0])

    //Initial value of preponement Of Future Income
    switch (Number(preponementOfFutureIncome_1)) {
        case 239:
            formRef.$("preponement-of-future-income").set("value", {
                id: preponementOfFutureIncome_1,
                label: 'Yes',
            });
            break;

        case 240:
            formRef.$("preponement-of-future-income").set("value", {
                id: preponementOfFutureIncome_1,
                label: 'No',
            });
            break;

        default:
            break;
    }
    // formRef.$("preponement-of-future-income").set("disabled", true);
    utils.handlePreponementOneCondition(formRef, preponementOfFutureIncome_1)

    // Initial value of ASB Start year 1
    let preponementStartYearOneList = utils.fetchPreponementStartYearOne(pptValue, ptValue, formRef.$("plan-option").value.id, formRef.$("pfi-start-policy-year-(1st-opt-in)").extra.preDefinedOptList, 'first', formRef) 
    formRef.$("pfi-start-policy-year-(1st-opt-in)").set("extra", {
        ...formRef.$("pfi-start-policy-year-(1st-opt-in)").extra,
        optionList: preponementStartYearOneList,
    });
    let preponementStartYearOneOpt = preponementStartYearOneList.filter((item) => Number(preponementStartYearOne) === item?.id)
    if(preponementStartYearOneOpt.length > 0) formRef.$("pfi-start-policy-year-(1st-opt-in)").set("value", preponementStartYearOneOpt[0])

     // Initial value of ASB End year 1
     let endYearOneList = utils.fetchPreponementEndYearList(formRef.$("pfi-start-policy-year-(1st-opt-in)").value.label, 
     formRef.$("policy-term").value.id,
     formRef.$("pfi-end-policy-year-(1st-opt-in)").extra.preDefinedOptList)
     formRef.$("pfi-end-policy-year-(1st-opt-in)").set("extra", {
         ...formRef.$("pfi-end-policy-year-(1st-opt-in)").extra,
         optionList: endYearOneList,
     });
     let endYearOneOpt = endYearOneList.filter((item) => Number(preponementEndYearOne) === item.id)
     if(endYearOneOpt.length > 0) formRef.$("pfi-end-policy-year-(1st-opt-in)").set("value", endYearOneOpt[0])

    //Initial value of preponement Of Future Income 2
    switch (Number(preponementOfFutureIncome_2)) {
        case 309:
            formRef.$("preponement-year-2").set("value", {
                id: preponementOfFutureIncome_2,
                label: 'Yes',
            });
            break;

        case 310:
            formRef.$("preponement-year-2").set("value", {
                id: preponementOfFutureIncome_2,
                label: 'No',
            });
            break;

        default:
            break;
    }
    utils.handlePreponementTwoCondition(formRef, preponementOfFutureIncome_2)

    // Initial value of Preponement Start year 2
    let twoStartYearOneList = utils.fetchPreponementStartYearOne(
        formRef.$("pfi-end-policy-year-(1st-opt-in)").value.label,
        ptValue,
        formRef.$("plan-option").value.id,
        formRef.$("pfi-start-policy-year-(2nd-opt-in)").extra.preDefinedOptList,
        'second',
        formRef
    );
    formRef.$("pfi-start-policy-year-(2nd-opt-in)").set("extra", {
        ...formRef.$("pfi-start-policy-year-(2nd-opt-in)").extra,
        optionList: twoStartYearOneList,
    });
     let twoStartYearOneOpt = twoStartYearOneList.filter((item) => Number(preponementStartYearTwo) === item.id)
     if(twoStartYearOneOpt.length > 0) formRef.$("pfi-start-policy-year-(2nd-opt-in)").set("value", twoStartYearOneOpt[0])
 
     // Initial value of Preponement End year 2
     let twoEndYearOneList = utils.fetchPreponementEndYearList(
        formRef.$("pfi-start-policy-year-(2nd-opt-in)").value.label, 
        formRef.$("policy-term").value.id,
        formRef.$("pfi-end-policy-year-(2nd-opt-in)").extra.preDefinedOptList)
     formRef.$("pfi-end-policy-year-(2nd-opt-in)").set("extra", {
         ...formRef.$("pfi-end-policy-year-(2nd-opt-in)").extra,
         optionList: twoEndYearOneList,
     });
     let twoEndYearOneOpt = twoEndYearOneList.filter((item) => Number(preponementEndYearTwo) === item.id)
     if(twoEndYearOneOpt.length > 0) formRef.$("pfi-end-policy-year-(2nd-opt-in)").set("value", twoEndYearOneOpt[0])

    //Initial value of preponement Of Future Income 3
    switch (Number(preponementOfFutureIncome_3)) {
        case 375:
            formRef.$("preponement-year-3").set("value", {
                id: preponementOfFutureIncome_3,
                label: 'Yes',
            });
            break;

        case 376:
            formRef.$("preponement-year-3").set("value", {
                id: preponementOfFutureIncome_3,
                label: 'No',
            });
            break;

        default:
            break;
    }
    utils.handlePreponementThreeCondition(formRef, preponementOfFutureIncome_3)
    // Initial value of Preponement Start year 3
    let thirdStartYearList = utils.fetchPreponementStartYearOne(
        formRef.$("pfi-end-policy-year-(2nd-opt-in)").value.label,
        ptValue,
        formRef.$("plan-option").value.id,
        formRef.$("pfi-start-policy-year-(3rd-opt-in)").extra.preDefinedOptList,
        'third',
        formRef
    );
    formRef.$("pfi-start-policy-year-(3rd-opt-in)").set("extra", {
        ...formRef.$("pfi-start-policy-year-(3rd-opt-in)").extra,
        optionList: thirdStartYearList,
    });
    let thirdStartYearOpt = thirdStartYearList.filter((item) => Number(preponementStartYearThree) === item.id)
    if(thirdStartYearOpt.length > 0) formRef.$("pfi-start-policy-year-(3rd-opt-in)").set("value", thirdStartYearOpt[0])

    // Initial value of Preponement End year 2
    let thirdEndYearList = utils.fetchPreponementEndYearList(
        formRef.$("pfi-start-policy-year-(3rd-opt-in)").value.label, 
        formRef.$("policy-term").value.id,
        formRef.$("pfi-end-policy-year-(3rd-opt-in)").extra.preDefinedOptList)
    formRef.$("pfi-end-policy-year-(3rd-opt-in)").set("extra", {
        ...formRef.$("pfi-end-policy-year-(3rd-opt-in)").extra,
        optionList: thirdEndYearList,
    });
    let threeEndYearOpt = thirdEndYearList.filter((item) => Number(preponementEndYearThree) === item.id)
    if(threeEndYearOpt.length > 0) formRef.$("pfi-end-policy-year-(3rd-opt-in)").set("value", threeEndYearOpt[0])

    //Initial value of auto Renewal Booster
    switch (Number(autoRenewalBooster)) {
        case 439:
            formRef.$("auto-renewal-booster").set("value", {
                id: autoRenewalBooster,
                label: 'Yes',
            });
            break;

        case 440:
            formRef.$("auto-renewal-booster").set("value", {
                id: autoRenewalBooster,
                label: 'No',
            });
            break;

        default:
            break;
    }

    //Initial value of sum assured on death multiple
    formRef.$('sum-assured-on-death-multiple').set('value', { label: saDeathMultiple, id: saDeathMultiple })
    if (formRef.$("premium-paying-term").value.id == 5) {
        formRef.$("sum-assured-on-death-multiple").set("disabled", false);

    }

 // For Lumpsum product
 let productName = data.data.product_name
 if(productName === ProductConstants.BHARAT_SAVINGS_STAR_LUMPSUM ||
    productName === ProductConstants.POS_BHARAT_SAVINGS_STAR_LUMPSUM) {
        formRef.$("accrual-of-survival-benefits").set("disabled", true)
        formRef.$("asb-start-policy-year-(1st-opt-in)").set("disabled", true)
        formRef.$("asb-end-policy-year-(1st-opt-in)").set("disabled", true)
        formRef.$("accrual-of-survival-benefits-year-2").set("extra", {
            ...formRef.$("accrual-of-survival-benefits-year-2").extra,
            hide: true,
        });
        formRef.$("preponement-of-future-income").set("disabled", true)
    }

 // RIDER INITIAL VALUES

    if (requestData.ADBRider) {
        formRef.$('ADB').set('value', requestData.ADBRider !== '')
        if (requestData.ADBRider) {
            formRef.$('ADB-dropdown').set('value', requestData.ADBRider)
        }
    }
    if (requestData.ATPDRider) {
        formRef.$('ATPDRider').set('value', requestData.ATPDRider !== '')
        if (requestData.ATPDRider) {
            formRef.$('ATPDRider-dropdown').set('value', requestData.ATPDRider)
        }
    }

    if (requestData.WaiverOfPremiumRider) {
        formRef.$('WaiverOfPremiumRider').set('value', requestData.WaiverOfPremiumRider !== '')
    }

    if (requestData.HospitalityCashBenefitRider) {
        formRef.$('HospitalityCashBenefitRider').set('value', requestData.HospitalityCashBenefitRider !== '')
        if (requestData.HospitalityCashBenefitRider) {
            formRef.$('HospitalityCashBenefitRider-dropdown').set('value', requestData.HospitalityCashBenefitRider)
        }
    }

    if (requestData.CriticalIllnessRider) {
        formRef.$('CriticalIllnessRider').set('value', requestData.CriticalIllnessRider !== '')
        if (formRef.$('CriticalIllnessRider').value) {
            formRef.$('CriticalIllnessRider-dropdown').set('value', requestData.CriticalIllnessRider)
        }
    }


                if(SameProposer) formRef.$('PayorWaiverBenefitRider').set('disabled', true)
                else formRef.$('PayorWaiverBenefitRider').set('disabled', false)

    if (requestData.PayorWaiverBenefitRider) {

        formRef.$('PayorWaiverBenefitRider').set('value', requestData.PayorWaiverBenefitRider !== '')
        
        if (formRef.$('PayorWaiverBenefitRider').value) {
            switch (requestData.PWB) {
                case '1':
                    formRef.$('PayorWaiverBenefitRider-dropdown').set('value', {
                        id: '1',
                        label: 'Option 1 (On Death)'
                    })
                    break;
                case '2':
                    formRef.$('PayorWaiverBenefitRider-dropdown').set('value', {
                        id: '2',
                        label: 'Option 2 (CI or ATPD)'
                    })
                    break;
                case '3':
                    formRef.$('PayorWaiverBenefitRider-dropdown').set('value', {
                        id: '3',
                        label: 'Option 3 (CI or ATPD or Death)'
                    })
                    break;
                default:
                    break;
            }
        }
    }
};
export default initialDefaults;

